import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface MemesLeaderboardDropCardProps {
  readonly drop: ExtendedDrop;
  readonly children: ReactNode;
}
const getBorderClasses = (drop: ExtendedDrop) => {
  const rank = drop.rank && drop.rank <= 3 ? drop.rank : null;
  const baseClasses = "tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden";
  if (rank === 1) {
    return `${baseClasses} desktop-hover:hover:tw-border-yellow-500/20`;
  } else if (rank === 2) {
    return `${baseClasses} desktop-hover:hover:tw-border-iron-400/25`;
  } else if (rank === 3) {
    return `${baseClasses} desktop-hover:hover:tw-border-amber-600/20`;
  } else {
    // More subtle hover effect for ranks 4+
    return `${baseClasses} desktop-hover:hover:tw-border-iron-700`;
  }
};
const MemesLeaderboardDropCard: React.FC<MemesLeaderboardDropCardProps> = t0 => {
  const $ = _c(5);
  const {
    drop,
    children
  } = t0;
  let t1;
  if ($[0] !== drop) {
    t1 = getBorderClasses(drop);
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const borderClasses = t1;
  const t2 = `${borderClasses} tw-bg-iron-950`;
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <div className="touch-select-none tw-rounded-xl tw-transition tw-duration-300 tw-ease-out tw-w-full"><div className={t2}>{children}</div></div>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default MemesLeaderboardDropCard;